<template>
    <div class="month-picker">
        <div v-for="it in months" :key="it.id"
             :class="{
                 active: it.id === value,
                 disabled: it.disabled,
             }"
             :title="it.hint"
             class="month"
             @click="select(it)"
        >
            {{ it.title }}
        </div>
    </div>
</template>

<script>
import { MONTHS_OF_YEAR } from '../../util.js';

export default {
    props: {
        value: {
            type: Number,
        },
        year: {
            type: Number,
        },
        minDate: {
            type: Date,
            required: true,
        },
        maxDate: {
            type: Date,
            required: true,
        },
    },
    computed: {
        months() {
            const result = [];

            for (let i = 0; i < MONTHS_OF_YEAR.length; i++) {
                const now = new Date(this.year, i);
                const disabled = now < this.minDate || now > this.maxDate;
                result.push({
                    id: i,
                    title: MONTHS_OF_YEAR[i],
                    disabled: disabled,
                    hint: disabled ? 'Месяц недоступен для выбора' : 'Выбрать месяц',
                });
            }

            return result;
        },
    },
    methods: {
        select(it) {
            if (it.disabled)
                return;

            this.$emit('input', it.id);
        },
    },
};
</script>

<style lang="scss" scoped>
.month-picker {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 20px;
    column-gap: 8px;

    .month {
        padding: 6px;
        cursor: pointer;
        border-radius: 4px;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: rgba(16, 24, 40, 0.7);
        text-align: center;

        &.active,
        &:not(.disabled):hover {
            background: #8887F0;
            color: #FFFFFF;
        }

        &.disabled {
            color: rgba(16, 24, 40, 0.25);
            cursor: not-allowed;
        }
    }
}
</style>
